import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';
// import { property_property } from './../../hotels/hotels-detail/types/property';
import { brandByExternalId_brandByExternalId } from './../graphql/types/brandByExternalId';

@Injectable({
  providedIn: 'root'
})
export class PropertyService {
  propertySubject = new ReplaySubject<any>(1);
  property$ = this.propertySubject.asObservable();

  brandSubject = new ReplaySubject<brandByExternalId_brandByExternalId>(1);
  brand$ = this.brandSubject.asObservable();

  constructor() { }
}
